import React from 'react';
import { Link } from '@inertiajs/react';

const RatingItem = ({ label, grade, explanation }) => (
    <div className="mb-3">
        <div className="card h-100">
            <div className="card-body">
                <h5 className="card-title">{label}: <span className="text-primary">{grade || 'N/A'}</span></h5>
                <p className="card-text">{explanation}</p>
            </div>
        </div>
    </div>
);

export default function RatingDisplay({ rating, scene }) {
    if (!rating) return null;
    return (
        <div className="mt-4">
            <h2 className="text-center mb-4">Scene Analysis</h2>
            <div className="card text-center mb-4">
                 <div className="card-header font-weight-bold">
                    Overall Score
                </div>
                <div className="card-body">
                    <h3 className="display-4 text-primary">{rating.score || 'N/A'}/100</h3>
                    <p className="card-text">{rating.ratingexplanation}</p>
                    <Link href={route('game.show_scene', { uid: scene.uid })} className="btn btn-secondary mt-2">
                        View Sharable Link
                    </Link>
                </div>
            </div>

            {rating.goal_rating && (
                 <div className="card bg-light mb-4">
                     <div className="card-header font-weight-bold">Goal-Specific Feedback</div>
                     <div className="card-body">
                        <p className="card-text">{rating.goal_rating}</p>
                     </div>
                 </div>
            )}
            
            <div className="row">
                <div className="col-md-6"><RatingItem label="Concept" grade={rating.conceptrating} explanation={rating.conceptexplanation} /></div>
                <div className="col-md-6"><RatingItem label="Plot" grade={rating.plotrating} explanation={rating.plotexplanation} /></div>
                <div className="col-md-6"><RatingItem label="Characters" grade={rating.charactersrating} explanation={rating.charactersexplanation} /></div>
                <div className="col-md-6"><RatingItem label="Dialogue" grade={rating.dialoguerating} explanation={rating.dialogueexplanation} /></div>
                <div className="col-md-6"><RatingItem label="Conflict" grade={rating.conflictlevel} explanation={rating.conflictexplanation} /></div>
                <div className="col-md-6"><RatingItem label="Pacing" grade={rating.pacingrating} explanation={rating.pacingexplanation} /></div>
            </div>
        </div>
    );
}

